import { StyledLayout } from '../../../globalStyledComponents/Layout'
import Footer from '../../../components/Footer'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useTranslation, getI18n } from 'react-i18next'
import LegalDE from './LegalDE'
import LegalEN from './LegalEN'

const { Content } = StyledLayout

const LegalInformation = () => {
  const { t } = useTranslation()

  return (
    <StyledLayout className="layout">
      <Content>
        <div className="header-with-inlines">
          <h1 style={{ margin: '50px 0' }}>{t('legal_information')}</h1>
          <Link to="/imprint" className="jump">
            <InfoCircleOutlined
              style={{ fontSize: '13px', margin: '4px 8px 0 2px' }}
            />
            {t('Provider')}
          </Link>
          <Link to="/data-privacy" className="jump">
            <InfoCircleOutlined
              style={{ fontSize: '13px', margin: '4px 8px 0 2px' }}
            />
            {t('Data protection')}
          </Link>
        </div>
        <div className="myevocard">
          {getI18n().resolvedLanguage === 'en' ? <LegalEN /> : <LegalDE />}
        </div>
      </Content>
      <Footer />
    </StyledLayout>
  )
}

export default LegalInformation
